import { createAsyncThunk } from '@reduxjs/toolkit';
import { ISearchAddress } from '@agco-onedigital/ecosystem-lib-frontend-utils';

import { addressSuggestions } from '../../../service/graphql/user/addressSuggestions';
import { registrationClient } from '../../../service/graphql/registration/registrationClient';
import { AsyncThunkConfig } from '../../store';
import { mockAddressSuggestions } from '../__mocks__/addressSuggestions';

export const addressSuggestionsThunk = createAsyncThunk<
  ISearchAddress[],
  { addressLine: string; countryCode: string },
  AsyncThunkConfig
>('user/addressSuggestions', async (addressInput, { getState }) => {
  const { launchDarkly } = getState();

  // Return mock data when running on localhost (development mode)
  if (process.env.NODE_ENV === 'development') {
    return mockAddressSuggestions;
  }

  const client = registrationClient(launchDarkly.data);

  return addressSuggestions(client, {
    addressLine: addressInput.addressLine,
    countryCode: addressInput.countryCode,
  });
});
